export interface CatalogEntry {
  entryCode: string;
  entryDesc: string;
  entryId: number;
}
